import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _type_of from "@swc/helpers/src/_type_of.mjs";
import * as Check from "./check";
var formatData = function(data) {
    return Object.entries(data).reduce(function(previousValue, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        var formattedEntry = "".concat(key, ": ").concat(value);
        return previousValue.length > 0 ? "".concat(previousValue, ", ").concat(formattedEntry) : formattedEntry;
    }, "");
};
var message = function(options, fallbackMessage) {
    var dataString = (options === null || options === void 0 ? void 0 : options.errorData) ? " (".concat(formatData(options.errorData), ")") : undefined;
    var message = (options === null || options === void 0 ? void 0 : options.errorMessage) || fallbackMessage;
    return dataString ? "".concat(message, " ").concat(dataString) : message;
};
var extendOptions = function(options, args) {
    var data = Object.prototype.hasOwnProperty.call(options, "data") ? options.errorData : {};
    return Object.assign({}, options, {
        data: _object_spread({}, args, data)
    });
};
export var isString = function(value) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!Check.isString(value)) {
        throw new Error(message(extendOptions(options, {
            value: value
        }), "Value not string"));
    }
};
export var isTruthy = function(value) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!Check.isTruthy(value)) {
        throw new Error(message(extendOptions(options, {
            value: value
        }), "Value not truthy"));
    }
};
export var isDefined = function(value) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!Check.isDefined(value)) {
        throw new Error(message(extendOptions(options, {
            value: value
        }), "Value undefined"));
    }
};
export var isNotNull = function(value) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (value !== null) {
        throw new Error(message(extendOptions(options, {
            value: value
        }), "Value null"));
    }
};
export var isType = function(value, test) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (Check.isString(test)) {
        if ((typeof value === "undefined" ? "undefined" : _type_of(value)) !== test) {
            throw new Error(message(extendOptions(options, {
                type: test,
                value: value
            }), "Value of incorrect type"));
        }
    } else {
        if (!test(value)) {
            throw new Error(message(extendOptions(options, {
                value: value
            }), "Value of incorrect type"));
        }
    }
};
export var implementsType = function(obj, schema) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!Check.implementsType(obj, schema, options)) {
        throw new Error(message(extendOptions(options, {
            schema: schema.id
        }), "Object failed schema validation"));
    }
};
